import { useState } from 'react'

import { useEvent } from '@tribeplatform/react-sdk/hooks'
import { Divider } from '@tribeplatform/react-ui-kit/Divider'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { InputCopy } from '@tribeplatform/react-ui-kit/Input'
import { Slider } from '@tribeplatform/react-ui-kit/Slider'

import { ErrorBoundary } from '../../../common/components/ErrorBoundary/ErrorBoundary.js'
import { useDomain } from '../../../common/index.js'
import { T } from '../../../i18n/index.js'

interface Props {
  eventId: string
}

export const EventEmbedCreator = ({ eventId }: Props) => {
  const { data: event, isFetching: fetchingEvent } = useEvent({
    variables: { id: eventId },
  })
  const { getResourceUrl } = useDomain()

  const baseUrl = getResourceUrl(`/embed/event/${eventId}`)
  const [iframeHeight, setIframeHeight] = useState(360)
  const iframeSrc = `${baseUrl}?readonly=true`

  if (fetchingEvent) {
    return (
      <div className="flex justify-center items-center w-full h-96">
        <SvgIcon className="animate-spin absolute h-9 w-9" name="spinner" />
      </div>
    )
  }

  return (
    <>
      <InputCopy
        value={`<iframe frameborder="no" src="${iframeSrc}" height="${iframeHeight}px" width="100%" title="${event?.title}" />`}
        readOnly
      />
      <Divider />
      <h5 className="text-sm font-medium">
        <T
          defaultMessage="Embed height: {iframe_height}px"
          id="Share.EmbedHeight"
          values={{
            iframe_height: iframeHeight,
          }}
        />
      </h5>
      <div className="mb-2">
        <Slider
          value={iframeHeight}
          step={10}
          min={200}
          max={1000}
          onChange={setIframeHeight}
        />
      </div>
      <ErrorBoundary>
        <h5 className="text-sm font-medium mb-1">
          <T defaultMessage="Embed preview" id="Share.EmbedPreview" />
        </h5>
        <div className="p-3 bg-skeleton overflow-auto h-96 rounded-base">
          <iframe
            src={iframeSrc}
            height={`${iframeHeight}px`}
            width="100%"
            title={event?.title}
          />
        </div>
      </ErrorBoundary>
    </>
  )
}
